import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext/AuthContext";
import { Button, Card, Flex, List, Result, Typography } from "antd";
import {
  BellOutlined,
  MailOutlined,
  UserOutlined,
  RocketOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { Organization } from "../../Interface/Index";
import UploadResumeCTA from "./UploadResumeCTA";

interface ZeroJobPostProps {
  organization: Organization;
}

const ZeroJobPost: React.FC<ZeroJobPostProps> = ({ organization }) => {
  const { isUserLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignUpClick = () => {
    const redirectUrl = location.pathname
      ? `/sign-up?redirect_url=${encodeURIComponent(location.pathname)}`
      : "/sign-up";
    navigate(redirectUrl);
  };

  if (!isUserLoggedIn) {
    return (
      <div className="message-section">
        <Flex align="center" justify="center" vertical gap={16}>
          <Result
            status="warning"
            title={`Thank you for your interest
            ${organization ? " in " + organization?.orgName : ""}. We dont have
            any openings at the moment.`}
            subTitle={"Please sign up and we will notify you when there is an available position."}
            extra={[
              <Button type="default" onClick={handleSignUpClick}>
                Sign Up
              </Button>,
            ]}
            style={{ maxWidth: 800 }}
          />
        </Flex>
      </div>
    );
  }

  const benefits = [
    {
      icon: <BellOutlined />,
      title: "Get Notified First",
      description: "We'll reach out when new positions open up",
    },
    // {
    //   icon: <UserOutlined />,
    //   title: "Recruiter Visibility",
    //   description: "Your profile will be reviewed by our recruiters",
    // },
    // {
    //   icon: <RocketOutlined />,
    //   title: "Quick Applications",
    //   description: "Apply faster when opportunities become available",
    // },
    // {
    //   icon: <FileTextOutlined />,
    //   title: "Keep Your Info Updated",
    //   description: "Maintain an up-to-date profile for future roles",
    // },
  ];

  return (
    <div className="message-section">
      <Flex
        align="center"
        justify="center"
        vertical
        gap={8}
        style={{ marginBottom: "16px" }}
      >
        <Result
          status="warning"
          title={`Thank you for your interest
            ${organization ? " in " + organization?.orgName : ""}. We dont have
            any openings at the moment.`}
          subTitle={"Please sign up and we will notify you when there is an available position."}
          extra={[
            <Button type="default" onClick={handleSignUpClick}>
              Sign Up
            </Button>,
          ]}
          style={{ maxWidth: 800 }}
        />
      </Flex>

      {/* Benefits Section */}
      <Card
        className="upload-benefits-card"
        style={{
          maxWidth: "600px",
          width: "100%",
          marginBottom: "16px",
        }} 
      >
        <List
          dataSource={benefits}
          renderItem={(item) => (
            <List.Item style={{ border: "none", padding: "8px 0" }}>
              <List.Item.Meta
                avatar={
                  <div
                    style={{
                      fontSize: "20px",
                      color: "var(--ant-color-primary)",
                    }}
                  >
                    {item.icon}
                  </div>
                }
                title={<Typography.Text strong> Why upload your resume?</Typography.Text>}
                description={
                  <Typography.Text type="secondary">
                    {item.description} {item.title}
                  </Typography.Text>
                }
              />
            </List.Item>
          )}
        />
        <UploadResumeCTA organization={organization} />
      </Card>

      
    </div>
  );
};

export default ZeroJobPost;
